/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { ProductAlertsQuery as SourceProductAlertsQuery } from 'SourceQuery/ProductAlerts.query';
import { Field } from 'Util/Query';

/** @namespace Bookland/Query/ProductAlerts/Query */
export class ProductAlertsQuery extends SourceProductAlertsQuery {
    /*
    ** input format
    ** {
    **    message: ""
    **    name: ""
    **    email: ""
    **    product_id: 0
    **    phone: ""
    ** }
    */
    getAskAboutProduct(input) {
        return new Field('askAboutProduct')
            .addArgument('input', 'askAboutProductInput', input);
    }

    /*
    ** input format
    ** {
    **    number: ""
    **    email: ""
    ** }
    */
    getFormMondly(input) {
        return new Field('formMondly')
            .addArgument('input', 'formMondlyInput', input);
    }
}

export default new ProductAlertsQuery();
